<!-- Rendu « café inversé » (MOKA-214) : toute la logique reste dans ce contrôleur. -->
<app-sidenav-cafe [mode]="mode" [isMobile]="isMobile" />
